import React, { useState } from "react";
import axios from "axios";
import "./AdSubmit.css";

const AdSubmit = () => {
  const [adType, setAdType]     = useState("text");
  const [text, setText]         = useState("");
  const [link, setLink]         = useState("");
  const [file, setFile]         = useState(null);
  const [maxViews, setMaxViews] = useState(100);
  const [loading, setLoading]   = useState(false);
  const [toast, setToast]       = useState(null);

  const BASE_URL =
    window.location.hostname === "localhost"
      ? "http://localhost:5000"
      : "https://success-blog-app-backend.onrender.com";

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("adType", adType);
      formData.append("text", text);
      formData.append("link", link);
      formData.append("maxViews", Number(maxViews));
      if (file) formData.append("file", file);
      await axios.post(`${BASE_URL}/api/ads/submit-ad`, formData);
      showToast("Ad submitted successfully ✅", "success");
      setText(""); setLink(""); setFile(null); setMaxViews(100);
    } catch (err) {
      showToast("Error submitting ad ❌", "error");
    } finally {
      setLoading(false);
    }
  };

  const AD_TYPES = [
    { value: "text",  label: "📝 Text Ad",  desc: "Plain text with a link" },
    { value: "image", label: "🖼 Image Ad",  desc: "Upload an image banner" },
    { value: "video", label: "🎥 Video Ad",  desc: "Upload a video clip"    },
  ];

  return (
    <div className="ads-wrapper">

      {/* TOAST */}
      {toast && (
        <div className={`ads-toast ads-toast-${toast.type}`}>{toast.msg}</div>
      )}

      <div className="ads-card">

        {/* HEADER */}
        <div className="ads-header">
          <div className="ads-badge">✦ Advertising</div>
          <h2 className="ads-title">Submit an Ad</h2>
          <p className="ads-sub">Create and submit your advertisement</p>
        </div>

        <form onSubmit={handleSubmit} className="ads-form">

          {/* AD TYPE SELECTOR */}
          <div className="ads-field">
            <label className="ads-label">Ad Type</label>
            <div className="ads-type-grid">
              {AD_TYPES.map(t => (
                <button
                  type="button"
                  key={t.value}
                  className={`ads-type-btn ${adType === t.value ? "ads-type-active" : ""}`}
                  onClick={() => setAdType(t.value)}
                >
                  <span className="ads-type-label">{t.label}</span>
                  <span className="ads-type-desc">{t.desc}</span>
                </button>
              ))}
            </div>
          </div>

          {/* TEXT AD */}
          {adType === "text" && (
            <>
              <div className="ads-field">
                <label className="ads-label">Ad Text</label>
                <textarea
                  className="ads-textarea"
                  placeholder="Write your ad text here..."
                  value={text}
                  onChange={e => setText(e.target.value)}
                  rows={4}
                />
              </div>
              <div className="ads-field">
                <label className="ads-label">Destination Link</label>
                <input
                  type="text"
                  className="ads-input"
                  placeholder="https://example.com"
                  value={link}
                  onChange={e => setLink(e.target.value)}
                />
              </div>
            </>
          )}

          {/* IMAGE / VIDEO */}
          {adType !== "text" && (
            <>
              <div className="ads-field">
                <label className="ads-label">
                  {adType === "image" ? "Upload Image" : "Upload Video"}
                </label>
                <div className="ads-file-wrap">
                  <input
                    type="file"
                    id="ads-file-input"
                    accept={adType === "image" ? "image/*" : "video/*"}
                    onChange={e => setFile(e.target.files[0])}
                    className="ads-file-hidden"
                  />
                  <label htmlFor="ads-file-input" className="ads-file-label">
                    {file
                      ? <><span className="ads-file-icon">✅</span> {file.name}</>
                      : <><span className="ads-file-icon">{adType === "image" ? "🖼" : "🎥"}</span> Choose {adType} file...</>
                    }
                  </label>
                </div>
              </div>
              <div className="ads-field">
                <label className="ads-label">Destination Link</label>
                <input
                  type="text"
                  className="ads-input"
                  placeholder="https://example.com"
                  value={link}
                  onChange={e => setLink(e.target.value)}
                />
              </div>
            </>
          )}

          {/* MAX VIEWS */}
          <div className="ads-field">
            <label className="ads-label">
              Max Views
              <span className="ads-label-hint"> — how many times to show this ad</span>
            </label>
            <input
              type="number"
              className="ads-input"
              placeholder="e.g. 1000"
              value={maxViews}
              min={1}
              onChange={e => setMaxViews(e.target.value)}
            />
          </div>

          {/* DIVIDER */}
          <div className="ads-divider" />

          {/* SUBMIT */}
          <button type="submit" className="ads-submit-btn" disabled={loading}>
            {loading
              ? <><span className="ads-spinner" /> Submitting...</>
              : <>✦ Submit Ad</>
            }
          </button>

        </form>
      </div>
    </div>
  );
};

export default AdSubmit;